module.exports = __webpack_public_path__ + "static/media/FFEP_230920.1fbd2c68.jpg";